<ng-container *ngIf="authServiceReady">
  <gains-layout *ngIf="authService.isLoggedIn()">
    <router-outlet></router-outlet>
  </gains-layout>
  <router-outlet *ngIf="!authService.isLoggedIn()"></router-outlet>

  <deo-ai-assistant-widget *ngIf="authService.isLoggedIn() && !isOnDeoAiAssist && isDeoAgentEnabled"></deo-ai-assistant-widget>
</ng-container>
